import {Box, Typography, Grid, Card} from '@mui/material';
import {useIsLargeDevice, useWrappedTheme} from '@jobseeker/lotus/hooks';
// import {Image} from '@jobseeker/lotus/components/Image';
import {Image} from '@jobseeker/lotus/components/Image';
import {useSelector} from 'react-redux';
import {AppState} from '@jobseeker/common-core/stores';

const AboutCompetitionSection = () => {
  const isAboveMobile = useIsLargeDevice(1024);
  const theme = useWrappedTheme();

  const {
    timelines: {
      config: {aboutCompetition},
    },
  } = useSelector((state: AppState) => state.competition);

  return (
    <Box id="about-competition" sx={{marginTop: 2, marginBottom: 4}}>
      <Card
        sx={{
          width: '100%',
          margin: '0 auto',
          padding: {xs: 2, md: 8},
          textAlign: 'left',
          borderRadius: 3,
          marginTop: 3,
          paddingTop: {xs: 0},
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            marginBottom: 1,
            display: 'flex',
            flexWrap: 'wrap',
          }}
        >
          <Grid item xs={12} md={8}>
            <Typography
              // variant="h4"
              sx={{
                fontSize: {
                  md: theme.typography.pxToRem(42),
                  xs: theme.typography.pxToRem(22),
                },
                fontWeight: 600,
                lineHeight: 1,
                color: '#000',
                textAlign: {xs: 'center', md: 'left'},

                padding: {xs: 2, md: 0},
              }}
            >
              <Typography
                // variant="h6"
                sx={{
                  display: 'block',
                  fontSize: {
                    md: theme.typography.pxToRem(30),
                    xs: theme.typography.pxToRem(18),
                  },
                  lineHeight: 1.4,
                  fontWeight: 300,
                }}
              >
                About
              </Typography>
              Competition
            </Typography>

            <Box
              sx={{
                fontSize: {
                  xs: theme.typography.pxToRem(16),
                  md: theme.typography.pxToRem(18),
                },
                textAlign: {xs: 'center', md: 'left'},
                marginTop: {xs: 0, md: 6},
                padding: {xs: 2, md: 0},
              }}
            >
              {aboutCompetition?.map((item: string, index: number) => (
                <Typography
                  key={index}
                  sx={{
                    fontSize: {xs: 16, md: 18},
                    fontWeight: 300,
                    lineHeight: 1.66,
                    marginBottom: 2,
                  }}
                  dangerouslySetInnerHTML={{__html: item}}
                />
              ))}
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                width: '100%',
                textAlign: 'right',
                padding: 0,
                '@media (max-width: 1024px)': {
                  maxWidth: '100%',
                  overflow: 'hidden',
                  paddingRight: 0,
                  paddingLeft: 0,
                },
                display: 'flex',
                justifyContent: isAboveMobile ? 'flex-end' : 'center',
              }}
            >
              <Image
                src={
                  isAboveMobile
                    ? 'https://static.iimjobs.com/epoch/static/assets/about-competition-image-new.svg'
                    : 'https://static.iimjobs.com/epoch/static/assets/about-competition-response-image-new.svg'
                }
                alt="About Competition"
                width={isAboveMobile ? 348 : 420}
                height={isAboveMobile ? 410 : 270}
                style={{
                  maxWidth: '100%',
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
};

export default AboutCompetitionSection;
